import enLang from './locales/en_US';
import azLang from './locales/az_AZ';

const AppLocale = {
    eng: enLang,
    aze: azLang,
};

export default AppLocale;
